module.exports = __webpack_public_path__ + "media/images/emblems/Sils_i_D_wappen-f4f8430ac20a7db22aa4ef054e84ffde.svg";